import { render, staticRenderFns } from "./MmplEdit.vue?vue&type=template&id=56751aee&scoped=true&"
import script from "./MmplEdit.vue?vue&type=script&lang=js&"
export * from "./MmplEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56751aee",
  null
  
)

export default component.exports